import { render, staticRenderFns } from "./mydocuments.html?vue&type=template&id=add7e5e2&"
import script from "./MyDocuments.vue?vue&type=script&lang=ts&"
export * from "./MyDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./MyDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports